import ConsolidatedToDoFeed from './ConsolidatedToDoFeed';

export default ConsolidatedToDoFeed;
